interface Course {
  icon: string;
  title: string;
  subtitle: string;
  iconColor?: string;
}

const courses: Course[] = [
  {
    icon: 'https://static.readdy.ai/image/e52027607460cffc32b49812e98784ba/9740ffb36dc71d45003a8538846887f2.png',
    title: 'Piano Clássico e Teclado',
    subtitle: 'Do repertório erudito ao contemporâneo',
  },
  {
    icon: 'https://static.readdy.ai/image/e52027607460cffc32b49812e98784ba/9ca747c8be033d3ad738a5e6ea166d35.png',
    title: 'Violão e Guitarra',
    subtitle: 'Técnica, harmonia e improvisação',
  },
  {
    icon: 'https://static.readdy.ai/image/e52027607460cffc32b49812e98784ba/05b8754f2150058fe6d22f83f2f8246d.png',
    title: 'Contrabaixo',
    subtitle: 'Fundamento rítmico com excelência',
  },
  {
    icon: 'https://static.readdy.ai/image/e52027607460cffc32b49812e98784ba/c578d8dbb8999365a1270663adaa82cb.png',
    title: 'Bateria',
    subtitle: 'Coordenação, groove e dinâmica',
  },
  {
    icon: 'https://static.readdy.ai/image/e52027607460cffc32b49812e98784ba/75dd29840c99c02146a7640311429663.png',
    title: 'Violino e Violoncelo',
    subtitle: 'Expressão e beleza nas cordas friccionadas',
  },
  {
    icon: 'ri-mic-line',
    title: 'Aula de Canto',
    subtitle: 'Técnica vocal, respiração e interpretação',
    iconColor: 'text-white',
  },
  {
    icon: 'ri-star-smile-line',
    title: 'Musicalização Infantil',
    subtitle: 'Despertar musical para os pequenos',
    iconColor: 'text-white',
  },
];

export default function CoursesSection() {
  return (
    <>
      <section id="cursos" className="relative w-full bg-strong-blue py-24 md:py-32">
        <div className="w-full px-6 md:px-12 lg:px-16">
          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-16">
            <div className="flex flex-col gap-3">
              <span className="font-sans text-[11px] font-semibold tracking-[0.2em] uppercase text-white/60 border border-white/20 self-start px-4 py-1.5 rounded-full">
                Nossos Cursos
              </span>
            </div>
            <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-[1.15] tracking-tight lg:text-right max-w-[500px] lg:max-w-[600px]">
              Escolha o seu instrumento.
            </h2>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-5">
            {courses.map((course, i) => (
              <div
                key={i}
                className="group bg-white/[0.06] hover:bg-white/[0.12] backdrop-blur-sm border border-white/10 hover:border-white/20 rounded-2xl p-6 md:p-7 flex flex-col items-center text-center gap-5 transition-all duration-400 cursor-pointer"
                style={{ animationDelay: `${i * 80}ms` }}
              >
                <div className="w-16 h-16 flex items-center justify-center rounded-xl bg-light-blue/15 group-hover:bg-light-blue/25 transition-colors">
                  {course.icon.startsWith('http') ? (
                    <img src={course.icon} alt={course.title} className="w-8 h-8 object-contain" />
                  ) : (
                    <i className={`${course.icon} text-2xl ${course.iconColor || 'text-light-blue'}`}></i>
                  )}
                </div>
                <div className="flex flex-col gap-1">
                  <span className="font-sans text-[15px] font-semibold text-white leading-snug">{course.title}</span>
                  <span className="font-sans text-[13px] text-white/50 leading-relaxed">{course.subtitle}</span>
                </div>
              </div>
            ))}
          </div>

          <div className="flex justify-center mt-14">
            <a
              href="https://wa.me/5516992188698?text=Ol%C3%A1%21+Vim+pelo+site+da+TL+Artes+%26+M%C3%BAsica+e+gostaria+de+saber+mais+informa%C3%A7%C3%B5es+sobre+as+aulas."
              target="_blank"
              rel="noopener noreferrer"
              className="group inline-flex items-center gap-3 bg-vibrant-blue hover:bg-vibrant-blue/90 text-white font-sans font-semibold text-sm tracking-wide uppercase px-10 py-4 rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Solicitar Vaga e Horários
              <span className="w-6 h-6 flex items-center justify-center">
                <i className="ri-arrow-right-line group-hover:translate-x-0.5 transition-transform"></i>
              </span>
            </a>
          </div>
        </div>
      </section>
    </>
  );
}